import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { KeyValue} from '@/main/models/common';
import { supplierApi } from '@/main/api';
import { HeadQuarterBranchFilterEnum } from '@/main/services/enum/HeadQuarterBranchFilterEnum';
import { SaveSupplierCompanyBuyerRequest } from '@/main/models/request/supplierRequest';
import {
  getTranslateByKey,
  isValueQueryParams,
  isNullUndefined
} from '@/main/services/utils';
import KogModalSideComponent from '@/main/components/modal/ModalSide';
import SecondaryButton from '@/main/components/shared/button/secondaryButton';
import { toast } from 'react-toastify';
import KogAutoCompleteControlled from '../../inputAutoComplete/autoCompleteControlled';
import useAsyncModalConfirmReason from '@/main/components/shared/asyncModalConfirmReason/asyncModalConfirmReason';
import { ReasonTypeEnum } from '@/main/services/enum/ReasonEnum';
import { toBase64 } from '@/main/services/utilsFile';
import * as S from './styles';
import {
  getCompanyType,
  useCompanyTypeReducer
} from '@/main/store/companyType';
import {
  getCompany,
  resetReducerCompany,
  useCompanyReducer
} from '@/main/store/company';
import { CompanyFilterRequest } from '@/main/models/request';
import { useDispatch } from 'react-redux';
import { CompanyTypeEnum } from '@/main/services/enum/CompanyTypeEnum';
import { ISupplierCompanyBuyerInfo } from '..';

interface Props {
  open?: boolean;
  closeModal: () => void;
  watcherCountry: KeyValue | null;
  guidSupplier: string | null;
  setSupplierCompanyBuyerGrid:React.Dispatch<React.SetStateAction<ISupplierCompanyBuyerInfo[]>>
}

function SupplierCompanyBuyerRegister({
  open,
  closeModal,
  watcherCountry,
  guidSupplier,
  setSupplierCompanyBuyerGrid
}: Props) {
  const dispatch = useDispatch();
  const companyTypeReducer = useCompanyTypeReducer();
  const companyReducer = useCompanyReducer();

  const INITIAL_FORM_STATE_SEARCH = {
    companyType: null as KeyValue | null,
    company: null as KeyValue | null,
  };
  type ISupplierCompanyBuyerFormSearch = typeof INITIAL_FORM_STATE_SEARCH;
  const {
    getValues,
    control,
    setValue,
    handleSubmit,
    reset,
    formState: {errors}
  } = useForm<ISupplierCompanyBuyerFormSearch>({
    mode: 'onChange',
    defaultValues: INITIAL_FORM_STATE_SEARCH
  });
  const [getConfirmationReason, ModalConfirmationReason] = useAsyncModalConfirmReason();

  const isDisabledCompanyDrop = () => getValues().companyType === null;

function AddCompanyToGrid(responseApi: any){
  setSupplierCompanyBuyerGrid(prev => [
    ...prev,
    {
      buyerName: responseApi.buyerName,
      guid: responseApi.guid,
      userDateTime: responseApi.userDateTime,
      companyTypeName: responseApi.companyTypeName
    }
  ]);
}

  async function onSubmitSave(formInputs: ISupplierCompanyBuyerFormSearch) {
      const resultConfirm = await getConfirmationReason(
        getTranslateByKey('information.confirmChangeTitle'),
        ReasonTypeEnum.ChangeCompany
      );

      if (!resultConfirm.confirmed) return;

      let filesRequest = undefined;
      if (resultConfirm.files && resultConfirm.files.length > 0) {
        filesRequest = await Promise.all(
          resultConfirm.files.map(async item => {
            const base64DataUrl = await toBase64(item);
            return {
              fileName: item.name,
              contentType: item.type,
              fileBase64: base64DataUrl as string
            };
          })
        );
      }

      const requestFormatted: SaveSupplierCompanyBuyerRequest = {
        guidSupplier: guidSupplier,
        guidCompany: String(formInputs.company?.key),
        idCompanyType: String(formInputs.companyType?.key),
        changeJustification: {
          guidReason: resultConfirm?.reason ? String(resultConfirm.reason.key) : null,
          reasonDescription: resultConfirm?.observation || null,
          filesUpload: filesRequest
        }
      };
      supplierApi
        .saveSupplierCompanyBuyer(requestFormatted)
        .then((response) => {
          const {result} = response.data

          AddCompanyToGrid(result)
          toast.success(
            getTranslateByKey('information.savedSuccess')
          );
          closeModal();
          handleClear();
        })
        .catch(error => { });
  }

  function callCompanyApiDomain(
    countrySelected: KeyValue | null,
    companyTypeSelected: KeyValue | null
  ) {
    if (!isValueQueryParams(countrySelected) || !isValueQueryParams(companyTypeSelected)) {
      setValue('company', null);
    }
    dispatch(resetReducerCompany());

    if (countrySelected !== null) {
      const request: CompanyFilterRequest = {
        guidCountry: String(countrySelected.key),
        type: HeadQuarterBranchFilterEnum.All
      };
      if (companyTypeSelected) {
        request.idCompanyType = String(companyTypeSelected.key);
        dispatch(getCompany(request));
      }
    }
  }

  function handleBack() {
    closeModal();
  }

  function handleClear() {
    reset(INITIAL_FORM_STATE_SEARCH);
    setValue('companyType', null);
    setValue('company', null);

  }
  useEffect(() => {
    dispatch(getCompanyType());

    return () => {
      dispatch(resetReducerCompany());
    }
  }, []);
const companyTypeIgnore = [CompanyTypeEnum.Admin,CompanyTypeEnum.Supplier, CompanyTypeEnum.Supervisor]
const companyTypeReducerFilter = isNullUndefined(companyTypeReducer.companyType.data) ? [] : companyTypeReducer.companyType.data.filter(item => !companyTypeIgnore.includes(Number(item.key)))
  return (
    <>
      {open && (
        <KogModalSideComponent
          open={open}
          closeModal={() => closeModal()}
          id="id-blacklist-modal-scroll"
          titleModalReducer={getTranslateByKey('information.registerbuyers')}
          title={
            <S.Title>
              {getTranslateByKey('information.registerbuyers')}
            </S.Title>
          }>
              <form
                  onSubmit={handleSubmit(onSubmitSave)}
                  noValidate>
              <S.Container>
                <KogAutoCompleteControlled
                  required
                  id="id-supplier_company-buyer-select-companyType"
                  label={getTranslateByKey('information.companyType')}
                  control={control}
                  options={companyTypeReducerFilter}
                  isLoading={companyTypeReducer.companyType.isLoading}
                  nameCustom="companyType"
                  rulesCustom={{ required: true }}
                  errorMessageCustom={
                    errors.companyType?.type === 'required'
                      ? getTranslateByKey('information.companyTypeRequired', true)
                      : ''
                  }
                  setValueCustom={setValue}
                  hasErrorCustom={!!errors.companyType}
                  onChangeCustom={(optionSelected: KeyValue | null) => {
                    callCompanyApiDomain(watcherCountry, optionSelected);
                  }}
                />
                <KogAutoCompleteControlled
                  id="id-supplier_company-buyer-select-company"
                  label={getTranslateByKey('information.company')}
                  control={control}
                  nameCustom="company"
                  rulesCustom={{ required: true }}
                  errorMessageCustom=""
                  hasErrorCustom={false}
                  options={companyReducer.company.data}
                  isLoading={companyReducer.company.isLoading}
                  onChangeCustom={() => { }}
                  disabled={isDisabledCompanyDrop()}
                  setValueCustom={setValue}
                />
                  <S.AreaButtons>
                  <SecondaryButton
                      id="id-holiday-btn-back"
                      onClick={handleBack}>
                      {getTranslateByKey('information.back')}
                    </SecondaryButton>
                    <SecondaryButton
                      type="submit"
                      id="id-supplierCompanyBuyerRegister-button-save">
                      {getTranslateByKey('information.save')}
                    </SecondaryButton>
                  </S.AreaButtons>
                </S.Container>
                </form>
        </KogModalSideComponent>
      )}
      <ModalConfirmationReason closeByOverlay={false} />
    </>
  );
}

export default SupplierCompanyBuyerRegister;
